<div class="tree-item-box" [class.has-loop]="item().hasLoop">
  @if (item().hasLoop) {
    <mat-icon fastTooltip="Loop detected">loop</mat-icon>
  }
  <ng-container *permissions="[Permission.WRITE_DEPENDENCY_TREE]">
    @if (item()?.active && item().entity.myTenant && !item().hideEdit) {
      <mat-slide-toggle
        color="accent"
        [checked]="item().active === 'active'"
        fastTooltip="Activate/Deactivate"
        [disabled]="item().entity?.disabled"
        (click)="onActiveChange()"
      ></mat-slide-toggle>
    }

    @if (!item().entity?.disabled && !item().hideEdit) {
      <button
        stopPropagation
        [preventDefault]="true"
        (click)="onEditMetadata()"
        semerisIconButton
        color="accent"
        fastTooltip="Edit metadata"
      >
        <mat-icon color="accent">edit_square</mat-icon>
      </button>
    }
  </ng-container>

  <div class="details">
    @if (item().routerLink) {
      <a class="display-name" [routerLink]="item().routerLink">{{ item().displayName }}</a>
    } @else {
      <span>{{ item().displayName }}</span>
    }
    <!-- <ng-container *ngIf="!item().routerLink">{{ item().displayName }}</ng-container> -->

    <div class="metadata">
      <div>
        @if (item().hasValue || item().hasError) {
          <span [class.has-value]="item().hasValue" [class.has-error]="item().hasError" class="angular-chip">
            {{ item().hasValue ? 'Calculated' : 'Error' }}
            @if (item().lastChangedAt) {
              <span class="additional-info">{{ item().lastChangedAt | userDateTimeFormat }}</span>
            }
          </span>
        }
        <span class="angular-chip" [ngClass]="item().type" [innerText]="dependencyTypeDisplayMapper[item().type]"></span>
        @if (item().extraInfo) {
          <span class="extra-type">{{ item().extraInfo }}</span>
        }
      </div>

      @if (item().entity) {
        <div>
          <semeris-asset-label [assets]="item().entity.assetShortNames"></semeris-asset-label>
          <semeris-user-entity-icons [entity]="item().entity"></semeris-user-entity-icons>
        </div>
      }
    </div>
  </div>

  @if (item().entity?.createdAt || item().entity?.updatedAt) {
    <semeris-crud-list-item-meta [compactMode]="true" [item]="item().entity"></semeris-crud-list-item-meta>
  }
</div>
